/* tslint:disable */
/* eslint-disable */
/**
 * TOM INTEGRATION API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContainerJourneyDto } from '../model';
/**
 * ReportsApi - axios parameter creator
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} tenantId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiInternalReportsGetContainerJourneysGet: async (tenantId: number, from?: string, to?: string, vesselVisitId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('integrationApiInternalReportsGetContainerJourneysGet', 'tenantId', tenantId)
            const localVarPath = `/integration/api/internal/Reports/GetContainerJourneys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['TenantId'] = tenantId;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (vesselVisitId !== undefined) {
                localVarQueryParameter['VesselVisitId'] = vesselVisitId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} tenantId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationApiInternalReportsGetContainerJourneysGet(tenantId: number, from?: string, to?: string, vesselVisitId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerJourneyDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationApiInternalReportsGetContainerJourneysGet(tenantId, from, to, vesselVisitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.integrationApiInternalReportsGetContainerJourneysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} tenantId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [vesselVisitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiInternalReportsGetContainerJourneysGet(tenantId: number, from?: string, to?: string, vesselVisitId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerJourneyDto>> {
            return localVarFp.integrationApiInternalReportsGetContainerJourneysGet(tenantId, from, to, vesselVisitId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @param {number} tenantId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {number} [vesselVisitId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public integrationApiInternalReportsGetContainerJourneysGet(tenantId: number, from?: string, to?: string, vesselVisitId?: number, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).integrationApiInternalReportsGetContainerJourneysGet(tenantId, from, to, vesselVisitId, options).then((request) => request(this.axios, this.basePath));
    }
}

